import React from 'react';

import { Box, Heading, Text } from '@primer/components'
import LazyLoad from 'react-lazyload'

import Challenge from './Challenge/Challenge'
import { useSearchRepositories } from '../hooks/useOctokit'
import { useProduct } from '../hooks/useProduct'


const imageStyle = {
  background: 'white',
  paddingLeft: '10px',
  paddingRight: '10px',
  paddingTop: '10px',
  borderTopLeftRadius: '5px',
  borderTopRightRadius: '5px',
}


export default function(props) {
  const [updateSerachParams, searchParams, repositories, retrievingRepositories, repositoriesTotalCount, isRateLimited] = useSearchRepositories()
  const productDetails = useProduct()

  return (
    <Box className="position-relative pl-md-0 pr-md-0 pl-4 pr-4">
      <div className="">
        <Box>
          <Box className="container-lg" padding="0">
            <Heading
              as="h2"
              marginBottom="40px"
              marginTop='80px'
            >Protect every code change automatically</Heading>
            <Text as="p" className="f3">{productDetails.name} reviews your GitHub pull requests to prevent adding vulnerabilities, performance, or maintainability issues to your code. The core review runs in the cloud so there is nothing to install locally. Cutting edge technology achieves near-zero noise for developers so you can follow best practices without changing how you work.</Text>
            <Box className="text-center mt-8 mb-8">
              <LazyLoad height="380px">
                <picture>
                 <source srcset="/check-small.png" media="(max-width: 600px)" />
                 <img src="/check.png" alt="" style={imageStyle} />
                </picture>
              </LazyLoad>
            </Box>
          </Box>
        </Box>
      </div>
    </Box>
  );
}
